import ArticleLayout from '@/components/feature/ArticleLayout';
import { articleTrending } from '@/mocks/articles';

export default function TrendingProductsPage() {
  return <ArticleLayout article={articleTrending} />;
}